// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for adding medication\'s display_name and category_code to StandardMedicationSetSerializer.
 * @see #/components/schemas/StandardMedicationMedicine - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface StandardMedicationMedicine {
    readonly display_name: string;
    /**
     * The medication category code(Id)
     *
     */
    category_code: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for StandardMedicationMedicine
 */
export namespace StandardMedicationMedicine {
    /**
     * StandardMedicationMedicine Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        readonly displayName: string;
        /**
         * The medication category code(Id)
         * @type string (`dataFormat` is missing)
         */
        categoryCode: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * StandardMedicationMedicine DTO
     * Transforms StandardMedicationMedicine model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend StandardMedicationMedicine model */
        static toModel(obj: StandardMedicationMedicine): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend StandardMedicationMedicine model */
        static toApi(obj: Model): StandardMedicationMedicine {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as StandardMedicationMedicine;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
